<template>
  <div class="container">
    <div class="content bgWhite">
      <!-- <better-scroll class="nav" :scrollX="true"> -->
      <div class="nav">
        <div class="wrapper">
          <span
            class="item"
            v-for="(item,index) in navList"
            :key="index"
            :class="{'item_active':item.select}"
            @click="goPage(index,item)"
          >{{item.type}}</span>
        </div>
      </div>
      <!-- </better-scroll> -->
    </div>
    <router-view class="child-view"></router-view>
  </div>
</template>

<script>
import api from "../../../../service/modules/appointment";
// import betterScroll from '../../../components/base/betterScroll'
// import betterScroll from '../../../components/base/betterScroll'

export default {
  components: {
    // 'better-scroll': betterScrollviews
  },
  data() {
    return {
      navList: [],
      tab: "",
      cityList: []
    };
  },
  created() {
    this.initTab();
  },
  watch:{
    $route(to,from){
      this.initTab();
    }
  },
  methods: {
    // 初始化tab选中项
    initTab() {
      this.navList = [
        {
          type: "统计分析",
          select: true,
          path: "/appointment/home/statistics"
        },
        {
          type: "分布分析",
          select: false,
          path: "/appointment/home/distribution"
        },
        { type: "入园预约单", select: false, path: "/appointment/home/list" }
      ];
      switch(this.$route.path) {
        case "/appointment/home/statistics":
        this.navList[0].select = true;
        break;
        case "/appointment/home/distribution":
        this.navList[1].select = true;
        this.navList[0].select = false;
        break;
        case "/appointment/home/list":
        this.navList[2].select = true;
        this.navList[0].select = false;
        break;
      }
    },
    goPage(index, item) {
      this.tab = index;
      this.$router.replace(item.path);
      this.navList.map((item, i) => {
        this.$set(this.navList[i], "select", false);
      });
      this.$set(this.navList[index], "select", true);
    }
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  .content {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 999;
    .nav {
      width: 100%;
      .wrapper {
        white-space: nowrap;
        position: absolute;
        width: 100%;
        background: #fbfbfb;
        padding: 10px 12px 0;
        .item {
          display: inline-block;
          padding: 10px 0;
          // border-bottom: 2px solid @base-color;
          font-size: 14px;
          margin: 0 10px;
          &:first-child {
            margin-left: 0;
          }
        }
        .item_active {
          border-bottom: 2px solid @base-color;
          padding-bottom: 6px;
          color: @base-color;
          font-weight: 600;
          padding-left: 0;
          padding-right: 0;
          // margin: 0 10px;
        }
      }
    }
  }
  .bgWhite {
    background-color: #fff;
  }
  .bgGray {
    background-color: #fbfbfb;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 50px;
    line-height: 50px;
    margin-top: 50px;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
</style>
